<template>
<!-- Main Content Area -->
<div class="reportVue">
    <!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="o-page-top-heading c-responsive-fixwidth">
                <div class="row c-responsive-fixwidth">
                    <div class="col-md-9">
                        <p class="u-back"><a href="javascript: void(0)" @click="backToJoblist()"><i class="fa fa-chevron-left"></i> Back</a></p>

                    </div>
                    <!-- <div class="col-md-3">
                        <div class="input-group stylish-input-group">
                            <input type="text" class="form-control" placeholder="Search">
                            <span class="input-group-addon">
                            <button type="submit">
                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                            </button>
                            </span>
                        </div>
                    </div> -->
                    <div class="col-md-12"><h1 class="h1">Report: {{job.title}}</h1></div>
                </div>
                
            </div>
            <!-- /Heading Section -->
        </div>
        <!-- /Main Body Content area -->

        <!-- Individual calls section area -->
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
                <div class="c-common-space o-individual-calls">
                    <div class="col-sm-3 skillset o-no-padding">
                        <span class="common-label-text">Report for:</span>
                        <span class="ps2 o-left-padding-5">  
                            <el-date-picker
                            v-model="selectedMonth"
                            @change="getAllCallsByMonth"
                            class="o-inline-datepicker-icon"
                            type="month"
                            format="MMMM yyyy"
                            placeholder="">
                        </el-date-picker>
                        </span>
                    </div>
                </div>
                <div class="c-common-space o-individual-calls u-margin-30">
                    <div class="col-md-12 o-no-padding">
                        <h5 class="c-common-heading">Total calls: {{totalCalls}}</h5>
                    </div>
                </div>
                <div class="row">
                    <div v-for="(call,index) in callList" :key="index" class="col-sm-10">
                        <div class="o-custom-table-container c-common-box-shadow c-radius3 report-small-table o-overflow-visible report-details-table">
                            <div class="o-calls-table c-common-gradient o-overflow-visible">
                                <div class="calls-table-row phonesheet-table-row">

                                    <div v-if="checkElement('call_times')" class="calls-table-cell">
                                        <div class="table-td-border-right">
                                            <div class="calls-table-cell-inner-table">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Start:</span>
                                                    <div>{{getTime(call.start)}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="checkElement('call_times')" class="calls-table-cell">
                                        <div class="table-td-border-right">
                                            <div class="calls-table-cell-inner-table">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>End:</span>
                                                    <div>{{getTime(call.end)}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="checkElement('position')" class="calls-table-cell">
                                        <div class="table-td-border-right">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Position:</span>
                                                <div>{{call.skill.name}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="checkElement('employee_name')" class="calls-table-cell">
                                        <div class="table-td-border-right">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Employee:</span>
                                                <div v-if="call.status.name=='Unassigned'">- - -</div>
                                                <div v-else>{{call.employee.employable.first_name+" "+call.employee.employable.last_name}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="checkElement('seniority')" lass="calls-table-cell">
                                        <div class="table-td-border-right">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Sen:</span>
                                                <div>
                                                    {{(call.status.name !='Unassigned')?call.employee.seniority:'NA'}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="checkElement('notes')" class="calls-table-cell">
                                        <div class="table-td-border-right">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Notes:</span>
                                                <div>
                                                    {{(call.notes.length>0)?call.notes:'- - -'}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="checkElement('call_status')" class="calls-table-cell">
                                        <div class="">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Status:</span>
                                                <div>{{call.status.name}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="checkElement('confirmed_by')" class="calls-table-cell">
                                        <div class="">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Confirmed By:</span>
                                                <div>----</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="checkElement('sms_sent')" class="calls-table-cell">
                                        <div class="">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Notify:</span>
                                                <div>{{getNotify(call.notified_at)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="callList.length==0 && afterAPI==true" class="o-ndividualTable">
                    <div class="c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3">
                        <div class="col-md-12 no-job-dispaly">
                            <i class="fa fa-frown-o" aria-hidden="true"></i>
                            <br />
                            No Result
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- /Individual calls section area -->      
</div>
<!-- /Main Content Area -->
</template>

<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    import service from '../../services.js';
    export default {
        data() {
            return {
                selectedMonth: '',
                callList: [],
                storeMore: [],
                loading: '',
                totalCalls: '',
                next_page: '',
                afterAPI: false,
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                job: 'getJob',
            })
        },
        methods: {
            getNotify(date){
                if(date){
                    return dateTimeConvert.utcTimeToUserTime(date);
                }
                return "---"
            },
            backToJoblist() {
                this.$router.push({
                    path: `/reportList`
                });
            },
            getAllCallsByMonth() {
                this.loading = true;
                this.afterAPI = false;
                this.storeMore = [];
                service.get('call/jobCallsByMonth', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'jobId': atob(this.$route.params.id),
                    'month': new Date(this.selectedMonth).getMonth() + 1,
                    'year': new Date(this.selectedMonth).getFullYear(),
                }).then((res) => {
                    this.loading = false;
                    this.callList = res.data.result.data;
                    this.totalCalls = res.data.result.total;
                    //console.log(this.callList);
                    this.next_page = res.data.result.next_page_url;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'jobId': atob(this.$route.params.id),// this.job.id,
                                'month': new Date(this.selectedMonth).getMonth() + 1,
                                'year': new Date(this.selectedMonth).getFullYear(),
                            })
                            .then((res) => {
                                this.storeMore = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;

                            }).catch((err) => {
                                console.log(err);
                            })
                    }
                    //this.loading=false;
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    //this.loading=false;
                });
            },
            loadMore() {
                if (this.storeMore.length != 0) {
                    var arr = this.callList;
                    this.storeMore.forEach(function(data) {
                        arr.push(data);
                    });
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'jobId': atob(this.$route.params.id), //this.job.id,
                                'month': new Date(this.selectedMonth).getMonth() + 1,
                                'year': new Date(this.selectedMonth).getFullYear(),
                            })
                            .then((res) => {
                                this.callList = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                            }).catch((err) => {
                                console.log(err);
                            })
                    } else {
                        this.storeMore = [];
                    }
                }
            },
            getDate(str) {
                return dateTimeConvert.globalDate(str);
                //var date = str.split(" ");
                //return date[0];
            },
            getTime(dateTime) {
                return dateTimeConvert.globalTime(dateTime);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },
            checkElement(value){
                // var index = this.callSettings.findIndex(data => data.name==value);
                // return index;
                // console.log(this.callSettings);
                for (var key in this.callSettings) {
                    if(this.callSettings[key]==value){
                        //console.log("true");
                        return true;
                    }
                }
                return false;
            },
            getClientSettings(){
                service.get('client/' + this.userClientID, {
                  'Authorization': this.userToken
              })
              .then((client) => {
                //   console.log(client);
                this.callSettings=client.data.result.settings['job-info-config-future'];                
              }).catch((err) => {
                  console.log(err);
              });
            }
        },
        created() {
            this.getClientSettings();
            this.selectedMonth = this.job.start.split(" ")[0];
            this.getAllCallsByMonth();
            
        }

    }

</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/report/report.vue